import { useCallback, useContext } from 'react'
import ExperienceSearchFilterDraftContext from 'contexts/Experience/ExperienceSearchFilterDraftContext'
import useQueryParams from 'hooks/useQueryParams'
import { useAppDispatch } from 'hooks/reduxHooks'
import { replace } from 'lib/routing/appRouting'

export default function useExperiencesSearchQuery({ appliedOnly = false } = {}) {
  const appliedQueryParams = useQueryParams()
  const draft = useContext(ExperienceSearchFilterDraftContext)
  const dispatch = useAppDispatch()
  const activeDraft = appliedOnly ? undefined : draft

  const replaceSearchUrl = useCallback((queryParams: URLSearchParams) => {
    if (activeDraft) {
      activeDraft.setQueryParams(queryParams)
    } else {
      dispatch(replace({ search: queryParams.toString() }))
    }
  }, [activeDraft, dispatch])

  return {
    queryParameters: activeDraft?.queryParams ?? appliedQueryParams,
    replaceSearchUrl,
    isDraft: !!activeDraft,
  }
}
